import {
  AdminProps,
  AdminActionTypes,
  GET_USERS,
  SET_USERS,
  GET_USERS_ORDERS,
  SET_USERS_ORDERS,
  SET_COOKMEALS,
  GET_COOKMEALS,
  SET_ADVERTISEMENT,
  GET_ADVERTISEMENT,
} from './types';

const initState: AdminProps = {
  users: [],
  orders: [],
  meals: [],
  advertisement: [],
};

export const adminReducer = (
  state = initState,
  action: AdminActionTypes
): AdminProps => {
  const { type, users, orders, meals, advertisement } = action;
  switch (type) {
    case GET_USERS:
      return state;
    case SET_USERS:
      return { ...state, users };
    case GET_USERS_ORDERS:
      return state;
    case SET_USERS_ORDERS:
      return { ...state, orders };
    case SET_COOKMEALS:
      return { ...state, meals: meals };
    case GET_COOKMEALS:
      return state;
    case GET_ADVERTISEMENT:
      return state;
    case SET_ADVERTISEMENT:
      return { ...state, advertisement: advertisement };
    default:
      return state;
  }
};
